import { fetcher } from '../utils'
import { ComponentKeyValueVO } from '@repo/types'

export default async (): Promise<ComponentKeyValueVO[]> => fetcher(`/api/keyValue/departments`, 'GET', undefined)
